import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./core-navigation.lazy.module').then(
    (module) => module.CoreNavigationLazyModule
  );

export const coreNavigationLazyImports: ComponentNameAndModule[] = [
  {
    path: 'Breadcrumb',
    canActivate: [],
    loadChildren,
  },
];
